export function DocumentCitationTooltipContent({
    blockText,
    title,
    pageNumber,
}: {
    blockText: string;
    title: string;
    pageNumber?: string;
}) {
    const pageNum = pageNumber && pageNumber !== "0" ? parseInt(pageNumber, 10) : null;
    const pageLabel = pageNum ? `Page ${pageNum}` : null;
    const excerptContent = blockText || (pageLabel ?? "No excerpt available for this reference.");

    const headerText = title || pageLabel || "Document reference";

    return (
        <div style={{ maxWidth: "400px", padding: "4px 0" }}>
            <div
                style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#374151",
                    marginBottom: "8px",
                }}
            >
                {headerText}
            </div>
            <div
                style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    lineHeight: "1.5",
                    whiteSpace: "pre-wrap",
                    maxHeight: "300px",
                    overflowY: "auto",
                }}
                className="citation-tooltip-content"
            >
                {excerptContent}
            </div>
        </div>
    );
}
